export default function CTASection() {
  return (
    <section id="download" className="py-16 md:py-20 bg-secondary-900" aria-labelledby="cta-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 id="cta-heading" className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 leading-tight">
              随时随地
              <br />
              <span className="text-accent-400">畅享漫画乐趣</span>
            </h2>
            <p className="text-sm text-foreground-100/70 mt-4 max-w-md leading-relaxed">
              下载jm漫画APP，享受更流畅的阅读体验。支持离线下载、夜间模式、智能推荐等独家功能。
            </p>

            <div className="flex flex-col sm:flex-row items-center lg:items-start gap-3 mt-8">
              <a
                href="#"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-foreground-900 font-semibold text-sm hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>

            <p className="text-xs text-foreground-100/40 mt-4">
              支持 iOS 14.0+ 和 Android 8.0+ 系统
            </p>
          </div>

          <div className="flex-shrink-0 relative">
            <div className="w-64 md:w-72 aspect-[3/4] rounded-2xl overflow-hidden bg-background-100 border-4 border-background-50/10 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20app%20mockup%20showing%20a%20manga%20comic%20reading%20app%20interface%20on%20a%20phone%20screen%2C%20displaying%20a%20colorful%20comic%20page%20with%20Japanese%20manga%20style%20art%2C%20clean%20modern%20UI%20with%20reading%20controls%2C%20warm%20dark%20theme%2C%20professional%20app%20design&width=400&height=560&seq=app-mockup-comic-01&orientation=portrait"
                alt="jm漫画APP界面预览"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-accent-500 flex items-center justify-center shadow-lg">
              <i className="ri-qr-code-line text-2xl md:text-3xl text-background-50"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}